import React, { useMemo } from 'react'
import classNames from 'classnames'
import { noop, uniqueId } from 'lodash'

import Single from '../SingleText'
import { Grid, Column } from '../../../Grid'
import { HORIZONTAL, VERTICAL } from '../../constant'

import './index.scss'

const PipeText = ({ data, config = {}, onClick = noop }) => {
  const { direction = HORIZONTAL, pipe = true, size, isInteractive } = config

  const formatGrid = useMemo(() => {
    const pipeContent = data.map((val) => (
      <Column
        key={uniqueId('KPI_PIPE_')}
        className={classNames({
          'KPI-pipe-border-bottom': pipe && direction === VERTICAL,
          'KPI-pipe-border-right': pipe && direction === HORIZONTAL
        })}
      >
        <Single
          data={val}
          size={size}
          onClick={onClick}
          isInteractive={isInteractive}
        />
      </Column>
    ))

    return pipeContent
  }, [data, direction, pipe])

  return (
    <Grid
      className={classNames('KPI-pipe-grid', {
        'KPI-pipe-vertical': direction === VERTICAL,
        'KPI-pipe-horizontal': direction === HORIZONTAL
      })}
    >
      {formatGrid}
    </Grid>
  )
}

export default PipeText
